import { useMutation } from "@tanstack/react-query";
import { createMyGoalReflection, type ApiError } from "@/lib/api";
import { queryClient } from "@/lib/queryClient";

/**
 * Viewer goal-reflection mutation (M7).
 *
 * `POST /api/my-feedback/goals/{id}/reflection` — a player or
 * guardian adds a reflection to one of their visible goals. On
 * success it invalidates BOTH the `["my-feedback"]` bundle (the
 * goal list there) AND every `["my-player-development", ...]`
 * query (the goal cards inside the Development tab), so the new
 * reflection surfaces wherever the goal is rendered.
 */
export function useMyGoalReflection() {
  const mutation = useMutation({
    mutationFn: ({
      goalId,
      reflection,
    }: {
      goalId: number;
      reflection: string;
    }) => createMyGoalReflection(goalId, reflection),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["my-feedback"] });
      queryClient.invalidateQueries({
        queryKey: ["my-player-development"],
      });
    },
  });
  return {
    submitReflection: (goalId: number, reflection: string) =>
      mutation.mutateAsync({ goalId, reflection }),
    isPending: mutation.isPending,
    error: (mutation.error as ApiError | null) ?? null,
  };
}
